export default (value: any): number | undefined => (typeof value === 'number' ? value : undefined);
